import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetAllTE_PM_TypeOfWork = createAsyncThunk(
  "dropdowns/GetAllTE_PM_TypeOfWork",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllTE_PM_TypeOfWork"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownTETypeOfWork = createSlice({
  name: "DropDownTETypeOfWork",
  initialState: {
    DropDownTETypeOfWork: [],
    loadingDropDownTETypeOfWork: false,
    errorDropDownTETypeOfWork: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTE_PM_TypeOfWork.pending, (state, action) => {
        state.loadingDropDownTETypeOfWork = true;
        state.DropDownTETypeOfWork = action.payload;
        state.errorDropDownTETypeOfWork = null;
      })
      .addCase(GetAllTE_PM_TypeOfWork.fulfilled, (state, action) => {
        state.loadingDropDownTETypeOfWork = false;
        state.DropDownTETypeOfWork = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllTE_PM_TypeOfWork.rejected, (state, action) => {
        state.loadingDropDownTETypeOfWork = false;
        state.errorDropDownTETypeOfWork = action.payload;
      });
  },
});

export default DropDownTETypeOfWork.reducer;
